
import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export const usePortfolioUpdates = () => {
  const { user } = useAuth();
  const [portfolioVersion, setPortfolioVersion] = useState(0);

  useEffect(() => {
    if (!user) return;

    // Listen for portfolio updates
    const portfolioChannel = supabase
      .channel('portfolio-updates')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'portfolio_items',
          filter: `user_id=eq.${user.id}`
        },
        () => {
          console.log('Portfolio updated, triggering refresh...');
          setPortfolioVersion(prev => prev + 1);
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(portfolioChannel);
    };
  }, [user]);

  return { portfolioVersion };
};
